import React from "react";
import { useRecoilState } from "recoil";

import {
	FormControl,
	FormLabel,
	FormControlLabel,
	Radio,
	RadioGroup,
} from "@mui/material";

import { VISITOR_AND_SPEND_TIME_SLOTS, visitorAndSpendOptionsAtom } from './atoms'

export default function TravelTypeSelector() {
	const [visitorAndSpendOptions, setVisitorAndSpendOptions] = useRecoilState(visitorAndSpendOptionsAtom)
  const [selectedTimeSlotValue, setSelectedTimeSlotValue] = React.useState(visitorAndSpendOptions.time_slot)
  const [timer, setTimer] = React.useState(null)

  const updateTimeSlotValue = (e) => {
  	clearTimeout(timer);
  	setSelectedTimeSlotValue(e.target.value)
  };

  const afterTimeout = () => {
    setVisitorAndSpendOptions({
      ...visitorAndSpendOptions,
      time_slot: selectedTimeSlotValue,
      day_or_night: VISITOR_AND_SPEND_TIME_SLOTS.find((ts) => ts.value === selectedTimeSlotValue).dayOrNight
    })
  }

  React.useEffect(() => {
		const t = setTimeout(afterTimeout, 100);
		setTimer(t)
  }, [selectedTimeSlotValue])

  const renderRadioButton = (tm) => {
  	return (
  		<Radio
  			aria-label={tm.label}
  			size="small" />
  	)
  }

	const renderRadioControl = (tm) => (
		<FormControlLabel
			key={tm.value}
			control={renderRadioButton(tm)}
			value={tm.value}
			label={tm.label}
			sx={{
				width: "180px",
				marginBottom: -1,
			}}/>
	)

	return (
		<FormControl sx={{
			mb: 2,
			ml: 3,
		}}>
			<FormLabel
				id="visitor-and-spend-time-slot-label"
				sx={{
					fontSize: "11px",
					color: '#868b8e',
					marginBottom: '2px',
				}}>
				Time slot
			</FormLabel>
			<RadioGroup
				row
				name="visitor-and-spend-time-slot-option"
				aria-labelledby="visitor-and-spend-time-slot-label"
				defaultValue={visitorAndSpendOptions.time_slot}
				onChange={updateTimeSlotValue}>
				{VISITOR_AND_SPEND_TIME_SLOTS.map((tm) => renderRadioControl(tm))}
			</RadioGroup>
		</FormControl>
	)
}